<template>
  <div class="number-spinner" v-bind:class="{ 'is-large': large }">
    <div class="field has-addons">
      <div class="control">
        <input
          type="number"
          :min="min"
          :max="max"
          :step="step"
          :disabled="disabled"
          :aria-label="label"
          class="input"
          v-bind:class="{ 'is-large': large }"
          v-model.number="currentValue"
          @blur="ensureClamped"
        />
      </div>
      <div class="control modifiers">
        <a href="#0" :aria-label="`Increase ${label}`" class="modifier up" @click.stop="plus" :class="{ 'is-disabled': disabled }"
          ><i class="fa fa-angle-up"></i
        ></a>
        <a href="#0" :aria-label="`Decrease ${label}`" class="modifier down" @click.stop="minus" :class="{ 'is-disabled': disabled }"
          ><i class="fa fa-angle-down"></i
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";

export default {
  name: "NumberSpinner",

  props: {
    value: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 999,
    },
    step: {
      type: Number,
      default: 1,
    },
    large: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String
    }
  },

  data() {
    return {
      currentValue: 0,
    };
  },

  computed: {
    minlength: {
      get() {
        return ("" + this.min).length;
      },
    },
    maxlength: {
      get() {
        return ("" + this.max).length;
      },
    },
  },

  methods: {
    plus: debounce(function() {
      if((this.currentValue + this.step) > this.max){
        this.$emit("maxReached");
      }

      this.currentValue = this.clamp(this.currentValue + this.step);
    }, 100),

    minus: debounce(function () {
      this.currentValue = this.clamp(this.currentValue - this.step);
    }, 100),

    clamp(value) {
      return value > this.max ? this.max : value < this.min ? this.min : value;
    },

    ensureClamped() {
      this.currentValue = this.clamp(this.currentValue);
    },
  },

  watch: {
    currentValue(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$emit("input", newVal);
      }
    },

    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentValue = newVal;
      }
    },
  },

  mounted() {
    this.currentValue = this.value;
  },
};
</script>
